module.exports = __webpack_public_path__ + "media/src/img/about-bg-01-88c18b59944f148eea614bf279e73a5a.jpg";